import { render, staticRenderFns } from "./item-autocomplete.vue?vue&type=template&id=6b3e8bf8&scoped=true"
import script from "./item-autocomplete.vue?vue&type=script&lang=js"
export * from "./item-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./item-autocomplete.vue?vue&type=style&index=0&id=6b3e8bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e8bf8",
  null
  
)

export default component.exports